import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import TokenDetection from '../views/TokenDetection.vue'

// Keep vue-router default encoding but allow a readable `address` query value
// (e.g. Sui style `0x..::module::COIN`) to remain unescaped in the URL.
// Note: this is cosmetic; URLs are valid either way.
const stringifyQuery = (obj = {}) => {
  const parts = []
  Object.keys(obj).forEach((key) => {
    const value = obj[key]
    if (value === undefined) return

    const encodeKey = encodeURIComponent(key)
    const encodeValue = (val) => {
      const encoded = encodeURIComponent(val)
      return key === 'address' ? encoded.replace(/%3A/gi, ':') : encoded
    }

    if (value === null) {
      parts.push(encodeKey)
      return
    }

    if (Array.isArray(value)) {
      value.forEach((v) => {
        if (v === undefined) return
        if (v === null) {
          parts.push(encodeKey)
        } else {
          parts.push(`${encodeKey}=${encodeValue(String(v))}`)
        }
      })
      return
    }

    parts.push(`${encodeKey}=${encodeValue(String(value))}`)
  })

  return parts.length ? `?${parts.join('&')}` : ''
}

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home,
  // },
  {
    path: '/',
    name: 'TokenDetection',
    component: TokenDetection,
  },
  // {
  //   path: '/tokenDetection',
  //   name: 'tokenDetection',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ '../views/TokenDetection.vue'),
  // },
]

const router = new VueRouter({
  routes,
  stringifyQuery,
})

//获取原型对象上的 replace 函数
const originalReplace = VueRouter.prototype.replace
//修改原型对象中的 replace 方法
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err)
}

export default router
